import {connect} from "react-redux";
import UCDLeadListing from "./List";
import {bindActionCreators} from "redux";
import {getLead, getLeadFilter} from "../../../../../service/Lead/action";

const mapStateToProps = (state) => ({
    leadList:state.Lead.leadList,
    leadFilter:state.Lead.leadFilter,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getLead,
            getLeadFilter
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(UCDLeadListing);
